// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FailureInfo_wrapper__36lzV","padding":"FailureInfo_padding__3qcML","info":"FailureInfo_info__32CxH"};